module.exports = __webpack_public_path__ + "b624bf10226ba33f6b897317458ba238.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/NP.svg
// module id = cu4k
// module chunks = 0